module.exports = __webpack_public_path__ + "ai-bot-body-think0wp9269e93a0fa704d25b4c82fb0e90d89f.png";